import { Component, Input } from '@angular/core';
import { FilterOutMilestonesPipe } from '../../pipes/filter-out-events.pipe';
import { DatePipe } from '@angular/common';
import { IsNotMidnightPipe } from '../../../../pipes/is-not-midnight.pipe';
import { AllEventsSkeletonComponent } from './all-events-skeleton/all-events-skeleton.component';
import { timeFormat } from '../../../../models/date-formats';
import { Shipment } from '../../../../pages/overview/models/shipment';
import { Container } from '../../../../pages/overview/models/container';

@Component({
  selector: 'app-all-events',
  standalone: true,
  templateUrl: './all-events.component.html',
  imports: [FilterOutMilestonesPipe, DatePipe, IsNotMidnightPipe, AllEventsSkeletonComponent],
  styleUrl: './all-events.component.scss'
})
export class AllEventsComponent {
  @Input() item: Shipment | Container | null = null;
  readonly timeFormat = timeFormat;
}
